import _ from 'lodash';

import {
  ImportDepartmentInput,
  useImportNetSuiteDepartmentsMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export type IColumnDef = ImportCsvModal.IColumnDescription<types.NetSuiteDepartmentsPropertyName>;



export const columnDefs: IColumnDef[] = [
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Name',
    label: 'Name',
    isRequired: true,
    formatType: undefined
  }
];



export function useImportNetSuiteDepartmentsFromCsv() {
  const [fnMutate, tuple] = useImportNetSuiteDepartmentsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = __formatTransform(rows);
      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



function __formatTransform(rawCsvRows: Array<_.Dictionary<string>>): ImportDepartmentInput[] {
  const rowsAsPropertyName2Value: ImportDepartmentInput[] = _.map(rawCsvRows, row => {
    return {
      netSuiteInternalId: row['Internal ID'],
      name: row['Name']
    };
  });

  return rowsAsPropertyName2Value;
}
